module.exports = __webpack_public_path__ + "img/karotte-icon.40fa18e5.png";